export const FETCH_FEEDBACK_LIST = 'FETCH_FEEDBACK_LIST'
export const FETCH_FEEDBACK_FORMS_LIST = 'FETCH_FEEDBACK_FORMS_LIST'
export const FETCH_CUSTOM_TABLE_FILTERS = 'FETCH_CUSTOM_TABLE_FILTERS'
export const FETCH_CUSTOM_TABLE_FILTER = 'FETCH_CUSTOM_TABLE_FILTER'
export const FETCH_CUSTOM_TABLE_FIELDS = 'FETCH_CUSTOM_TABLE_FIELDS'

export const FETCH_FEEDBACK_DETAILS = 'FETCH_FEEDBACK_DETAILS'
export const FETCH_FEEDBACK_DETAILS_ANSWERS = 'FETCH_FEEDBACK_DETAILS_ANSWERS'
export const FETCH_FEEDBACK_DETAILS_TASKS = 'FETCH_FEEDBACK_DETAILS_TASKS'
